import { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { ConsentContext } from '../../context/ConsentContext';

const ErrorContainer = () => {
  const { consentFlow } = useContext(ConsentContext);
  const navigate = useNavigate();
  const onRetry = () => {
    void navigate('/smart-meter/' + consentFlow);
  };

  return (
    <>
      <h1>Something went wrong</h1>
      <p>Something happened while N3rgy were processing your MPAN and we weren&apos;t able to sign you up correctly.</p>
      <p>If you would like to try again, please click the button below.</p>
      <Button variant="primary" className="w-100" type="button" onClick={onRetry}>
        Re-Enter your address
      </Button>
    </>
  );
};

export default ErrorContainer;
